import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { IntRange } from '../../../../../models/int-range/int-range';
import { StarQuestion } from '../../../../../models/questions/star-question.model';
import { IonLabel } from '@ionic/angular/standalone';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-scale-question-labels',
  templateUrl: './scale-question-labels.component.html',
  styleUrls: ['./scale-question-labels.component.scss'],
  imports: [IonLabel],
})
export class ScaleQuestionLabelsComponent {
  /**
   * StarQuestion input signal.
   */
  public readonly questionData: InputSignal<StarQuestion> =
    input.required<StarQuestion>();

  /**
   * Possible ratings in an array, taken from the questionData.scaleRange.
   * Usually [1, 2, 3, 4, 5], but does not have to start on 1, so can also be [2, 3, 4].
   */
  protected readonly rangeArray: Signal<number[]> = computed<number[]>(() => {
    const scaleRange: IntRange = this.questionData()?.scaleRange;
    const result: number[] = [];
    for (let i: number = scaleRange.min; i <= scaleRange.max; i++) {
      result.push(i);
    }
    return result;
  });

  /**
   * Determines if there is a scale question label that needs to be added at this position.
   */
  public hasScaleQuestionLabelOnPosition(position: number): boolean {
    return this.questionData().scaleQuestionLabels.some(
      (label) => label.onScalePoint === position,
    );
  }

  /**
   * Get the current label based on the given position.
   */
  public getScaleQuestionLabel(position: number): string {
    return (
      this.questionData().scaleQuestionLabels.find(
        (label) => label.onScalePoint === position,
      )?.title ?? ''
    );
  }
}
